var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.55 20.625V15.9375H27.6V12.8125L33 18.2813L27.6 23.75V20.625H23.55ZM22.2 10.7812V12.8125H6V10.7812L14.1 5L22.2 10.7812ZM12.75 14.375H15.45V22.1875H12.75V14.375ZM7.35 14.375H10.05V22.1875H7.35V14.375ZM20.85 14.375V18.2813L18.15 21.0938V14.375H20.85ZM15.585 23.75L14.775 24.5312L17.07 26.875H6V23.75H15.585ZM26.25 22.1875V26.875H22.2V30L16.8 24.5312L22.2 19.0625V22.1875H26.25Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankR);
export default __webpack_public_path__ + "static/media/bankR.3a55734b735cc2db7dd8a2dcc6a4fb6c.svg";
export { ForwardRef as ReactComponent };